import {
  FormControl,
  FormHelperText,
  Grid,
  Input,
  MenuItem,
  Select,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import React, { Ref } from "react";
import { convertDate } from "../utils/dateConvert";

const DescGrid = styled(Grid)(({ theme }) => ({
  padding: "1%",
}));

const TitleGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: "10%",
}));
const HelperGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: "11%",
}));

const InputWidth = styled(TextField)(({ theme }) => ({
  width: "80%",
}));

type Props = {
  title: string;
  value: any;
  handleEdit: (e: any) => void;
  helperText?: string;
  helperTextColor?: string;
};

export default function InputDate({
  title,
  value,
  handleEdit,
  helperText,
  helperTextColor = "error",
}: Props) {
  return (
    <Grid container justifyContent="center">
      <DescGrid container justifyContent="center">
        <TitleGrid item xs={12}>
          <Typography component="span" variant="h6" color="black">
            {title}
          </Typography>
        </TitleGrid>
        <Grid container justifyContent="center" item xs={12}>
          <Flatpickr
            render={({ ...props }, ref: Ref<HTMLInputElement>) => {
              return <InputWidth value={convertDate(value)} inputRef={ref} />;
            }}
            value={convertDate(value)}
            options={{
              allowInput: true,
              dateFormat: "j/n/Y",
            }}
            onChange={(e: any) => {
              handleEdit(e[0]);
            }}
          />
        </Grid>
        <HelperGrid container justifyContent="flex-start">
          <FormHelperText>
            <Typography component="span" sx={{ fontSize: "0.75rem" }} color={helperTextColor}>
              {helperText}
            </Typography>
          </FormHelperText>
        </HelperGrid>
      </DescGrid>
    </Grid>
  );
}
